import { flattenObjectWithPath, areValuesSemanticallySame } from '../../../GoalData/DataEntryModal/utils/validationUtils';

// Helper function to track changes in behavior data entries
export const trackBehaviorDataChanges = (existingEntry, newFormData) => {
  const changes = [];

  const existingDataPoints = existingEntry?.info || [];
  const newDataPoints = newFormData || [];

  const existingDataPointsMap = new Map();
  const newDataPointsMap = new Map();

  existingDataPoints.forEach((dp) => {
    if (dp?.id) {
      existingDataPointsMap.set(dp.id, dp);
    }
  });

  newDataPoints.forEach((dp) => {
    if (dp?.id) {
      newDataPointsMap.set(dp.id, dp);
    }
  });

  const matchedIds = new Set();

  newDataPoints.forEach((newDP, index) => {
    if (existingDataPointsMap.has(newDP?.id)) {
      const existingDP = existingDataPointsMap.get(newDP.id);
      matchedIds.add(newDP.id);

      const dataPointPrefix = `Data Point #${index + 1}`;
      const flatExistingDP = flattenObjectWithPath(existingDP || {});
      const flatNewDP = flattenObjectWithPath(newDP || {});

      const allFields = new Set([
        ...Object.keys(flatExistingDP),
        ...Object.keys(flatNewDP),
      ]);

      allFields.forEach((fieldPath) => {
        if (fieldPath === 'id' || fieldPath === 'currentTime') return;

        let existingValue = flatExistingDP[fieldPath];
        let newValue = flatNewDP[fieldPath];

        // Filter out system fields that shouldn't appear in activity log
        const isSystemField =
          fieldPath.includes('createdAt') ||
          fieldPath.includes('updatedAt') ||
          fieldPath.includes('timestamp') ||
          fieldPath.includes('id') ||
          fieldPath.includes('_id') ||
          fieldPath.includes('isEncrypted') ||
          fieldPath.includes('activityLog');

        if (
          !isSystemField &&
          !areValuesSemanticallySame(existingValue, newValue)
        ) {
          changes.push({
            fieldName: `${dataPointPrefix} > ${fieldPath}`,
            oldValue: existingValue,
            newValue: newValue,
          });
        }
      });
    }
  });

  newDataPoints.forEach((newDP) => {
    if (!existingDataPointsMap.has(newDP?.id)) {
      changes.push({
        fieldName: 'New data point added',
        oldValue: '',
        newValue: '',
      });
    }
  });

  existingDataPoints.forEach((existingDP) => {
    if (!newDataPointsMap.has(existingDP?.id)) {
      changes.push({
        fieldName: 'Data point deleted',
        oldValue: '',
        newValue: '',
      });
    }
  });

  return changes;
};

export default trackBehaviorDataChanges;


